import { loginSuccess } from "../../../store/slices/authSlice";

export default function responseUpdateProfile(response: any, api: any, arg: any) {
    console.log('update profile response', response);
    if (response?.data) {
        // Update the user in Redux store and localStorage
        const token = localStorage.getItem("google_token");
        api.dispatch(loginSuccess({ token, user: response.data }));
    }
    return response?.data || null;
}